import { OrganizationFeature } from '../interfaces/organization';
import { DeepReadonly } from 'utility-types';

export const isComplianceRegionUS = (features: DeepReadonly<OrganizationFeature[]>) =>
  features.includes(OrganizationFeature.ComplianceUSA);

export const isComplianceRegionCHAS = (features: DeepReadonly<OrganizationFeature[]>) =>
  [OrganizationFeature.ComplianceUK, OrganizationFeature.ComplianceAUS].some(value => features.includes(value)) &&
  !features.includes(OrganizationFeature.ComplianceUSA);

export const isComplianceRegionGlobal = (features: DeepReadonly<OrganizationFeature[]>) => {
  return features.includes(OrganizationFeature.ComplianceGlobal);
};

/// <summary>
/// Maps an organization's compliance features to the compliance location string
/// expected by the V304 contractor search API (e.g. "Global", "Standard", "GB", "AU").
/// Returns undefined when no compliance feature is present (no region filter applied).
/// </summary>
export const getComplianceLocation = (features: DeepReadonly<OrganizationFeature[]>): string | undefined => {
  if (isComplianceRegionGlobal(features)) return 'Global';
  if (isComplianceRegionUS(features)) return 'Standard';
  if (features.includes(OrganizationFeature.ComplianceUK)) return 'GB';
  if (features.includes(OrganizationFeature.ComplianceAUS)) return 'AU';
  return undefined;
};
